import { ReactNode } from "react";

import { Viewer3DType } from "@plansoft-configuration-renderer/components";

import { useCADViewer3D } from "@/hooks/useCADViewer3D";

export default function CustomCadClickViewer3DController(): ReactNode {
  const viewer: Viewer3DType | null = useCADViewer3D();

  console.debug("current CadClickViewer3D: ", viewer);

  return <></>;
}
